<!-- 机构旗下师傅（挂靠管理）：申请审核 Tab + 在册/历史 Tab；同意/拒绝/解聘操作 -->
<template>
  <div class="p-20px">
    <el-card shadow="never">
      <el-tabs v-model="activeTab" @tab-change="handleTabChange">
        <!-- Tab 1：申请审核（待确认 + 已拒绝历史） -->
        <el-tab-pane label="挂靠申请" name="apply">
          <el-form :inline="true" :model="queryParams" class="-mb-15px" label-width="70px">
            <el-form-item label="状态" prop="status">
              <el-select v-model="statusFilter" placeholder="全部" clearable class="!w-140px" @change="handleQuery">
                <el-option label="待确认" :value="0" />
                <el-option label="已拒绝" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item label="师傅" prop="masterName">
              <el-input v-model="queryParams.masterName" placeholder="师傅姓名" clearable class="!w-180px" @keyup.enter="handleQuery" />
            </el-form-item>
            <el-form-item>
              <el-button @click="handleQuery"><Icon icon="ep:search" class="mr-5px" /> 搜索</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- Tab 2：在册/历史（已挂靠 + 退出/解聘） -->
        <el-tab-pane label="在册师傅" name="joined">
          <el-form :inline="true" :model="queryParams" class="-mb-15px" label-width="70px">
            <el-form-item label="状态" prop="status">
              <el-select v-model="statusFilter" placeholder="全部" clearable class="!w-140px" @change="handleQuery">
                <el-option label="已挂靠" :value="1" />
                <el-option label="师傅退出" :value="3" />
                <el-option label="机构解聘" :value="4" />
              </el-select>
            </el-form-item>
            <el-form-item label="师傅" prop="masterName">
              <el-input v-model="queryParams.masterName" placeholder="师傅姓名" clearable class="!w-180px" @keyup.enter="handleQuery" />
            </el-form-item>
            <el-form-item>
              <el-button @click="handleQuery"><Icon icon="ep:search" class="mr-5px" /> 搜索</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>

      <el-table v-loading="loading" :data="list">
        <el-table-column label="师傅" align="center" prop="masterName" min-width="110">
          <template #default="{ row }">
            <span class="mr-4px inline-flex h-22px w-22px items-center justify-center rounded-6px bg-[#f5efe3] text-13px font-600 text-[#b2862f]">
              {{ row.sealChar || (row.masterName || '师').slice(0, 1) }}
            </span>
            {{ row.masterName }}
          </template>
        </el-table-column>
        <el-table-column label="品类" align="center" width="100">
          <template #default="{ row }">{{ MASTER_CATEGORY_LABELS[row.category] ?? row.category ?? '—' }}</template>
        </el-table-column>
        <el-table-column label="年限" align="center" width="80">
          <template #default="{ row }">{{ row.years != null ? row.years + ' 年' : '—' }}</template>
        </el-table-column>
        <el-table-column label="申请留言" align="center" prop="applyRemark" min-width="150" show-overflow-tooltip>
          <template #default="{ row }">{{ row.applyRemark || '—' }}</template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="90">
          <template #default="{ row }">
            <el-tag :type="AFFILIATION_STATUS_TAG_TYPES[row.status] ?? 'info'">
              {{ AFFILIATION_STATUS_LABELS[row.status] ?? row.status }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" min-width="140" show-overflow-tooltip>
          <template #default="{ row }">
            {{ row.status === 2 ? row.auditRemark : row.exitReason || '—' }}
          </template>
        </el-table-column>
        <el-table-column label="生效时间" align="center" prop="joinTime" width="170">
          <template #default="{ row }">{{ row.joinTime || '—' }}</template>
        </el-table-column>
        <el-table-column label="申请时间" align="center" prop="createTime" width="170">
          <template #default="{ row }">{{ row.createTime || '—' }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="140" fixed="right">
          <template #default="{ row }">
            <template v-if="row.status === 0">
              <el-button link type="primary" @click="openAudit(row, true)">同意</el-button>
              <el-button link type="danger" @click="openAudit(row, false)">拒绝</el-button>
            </template>
            <el-button v-else-if="row.status === 1" link type="danger" @click="openDismiss(row)">解聘</el-button>
            <span v-else>—</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination v-model:limit="queryParams.pageSize" v-model:page="queryParams.pageNo" :total="total" @pagination="getList" />
    </el-card>

    <!-- 审核（同意/拒绝）弹窗 -->
    <el-dialog v-model="auditVisible" :title="auditForm.approved ? '同意挂靠' : '拒绝申请'" width="480px">
      <el-form label-width="90px">
        <el-form-item label="申请师傅">{{ current?.masterName }}</el-form-item>
        <el-form-item label="审核结论">
          <el-radio-group v-model="auditForm.approved">
            <el-radio :value="true">同意（挂靠生效）</el-radio>
            <el-radio :value="false">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拒绝原因" v-if="!auditForm.approved">
          <el-input v-model="auditForm.remark" type="textarea" :rows="3" maxlength="255" placeholder="请填写拒绝原因（必填）" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="auditVisible = false">取消</el-button>
        <el-button type="primary" :loading="operating" @click="handleAudit">确定</el-button>
      </template>
    </el-dialog>

    <!-- 解聘弹窗 -->
    <el-dialog v-model="dismissVisible" title="解聘师傅" width="480px">
      <el-form label-width="90px">
        <el-form-item label="师傅">{{ current?.masterName }}</el-form-item>
        <el-form-item label="解聘原因">
          <el-input v-model="dismissReason" type="textarea" :rows="3" maxlength="255" placeholder="请填写解聘原因（必填）" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dismissVisible = false">取消</el-button>
        <el-button type="danger" :loading="operating" @click="handleDismiss">确定解聘</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import {
  AffiliationApi,
  AFFILIATION_STATUS_LABELS,
  AFFILIATION_STATUS_TAG_TYPES,
  type AffiliationVo
} from '@/api/xuanxue/institution'

defineOptions({ name: 'MerchantXuanxueAffiliation' })

const message = useMessage()

const MASTER_CATEGORY_LABELS: Record<string, string> = {
  bazi: '命理八字',
  feng: '风水堪舆',
  qimen: '奇门遁甲',
  liuren: '六壬神课'
}

const loading = ref(true)
const total = ref(0)
const list = ref<AffiliationVo[]>([])
const activeTab = ref<'apply' | 'joined'>('apply')
const statusFilter = ref<number | undefined>(0)
const queryParams = reactive({
  pageNo: 1,
  pageSize: 10,
  masterName: undefined as string | undefined,
  status: undefined as number | undefined
})

/** 切 Tab：先设默认状态筛选再查询（tab-change 同步于 watch 之前，合并到一处避免时序错位） */
const handleTabChange = (name: string | number) => {
  statusFilter.value = name === 'apply' ? 0 : 1
  handleQuery()
}

const getList = async () => {
  loading.value = true
  try {
    const data = await AffiliationApi.getPage({ ...queryParams, status: statusFilter.value })
    list.value = data.list
    total.value = data.total
  } finally {
    loading.value = false
  }
}

const handleQuery = () => {
  queryParams.pageNo = 1
  getList()
}

// ── 审核（同意/拒绝）──
const auditVisible = ref(false)
const operating = ref(false)
const current = ref<AffiliationVo | null>(null)
const auditForm = reactive({ id: 0, approved: true, remark: '' })

const openAudit = (row: AffiliationVo, approved: boolean) => {
  current.value = row
  auditForm.id = row.id
  auditForm.approved = approved
  auditForm.remark = ''
  auditVisible.value = true
}

const handleAudit = async () => {
  if (!auditForm.approved && !auditForm.remark.trim()) {
    message.error('拒绝时请填写拒绝原因')
    return
  }
  operating.value = true
  try {
    await AffiliationApi.audit({
      id: auditForm.id,
      approved: auditForm.approved,
      remark: auditForm.remark.trim() || undefined
    })
    message.success(auditForm.approved ? '已同意，挂靠关系生效' : '已拒绝')
    auditVisible.value = false
    await getList()
  } finally {
    operating.value = false
  }
}

// ── 解聘 ──
const dismissVisible = ref(false)
const dismissReason = ref('')

const openDismiss = (row: AffiliationVo) => {
  current.value = row
  dismissReason.value = ''
  dismissVisible.value = true
}

const handleDismiss = async () => {
  if (!dismissReason.value.trim()) {
    message.error('请填写解聘原因')
    return
  }
  operating.value = true
  try {
    await AffiliationApi.dismiss({ id: current.value!.id, reason: dismissReason.value.trim() })
    message.success('已解聘')
    dismissVisible.value = false
    await getList()
  } finally {
    operating.value = false
  }
}

onMounted(() => {
  getList()
})
</script>
